import { SendMethod } from '@/features/extrajudicial/types';
import type { RootState } from '@/store';

export const selectLoteForm = (state: RootState) => state.extrajudicial.form;
export const selectTemplates = (state: RootState) => state.extrajudicial.templates;
export const selectTemplatesLoading = (state: RootState) => state.extrajudicial.isLoadingTemplates;
export const selectDownloadingTemplate = (state: RootState) =>
  state.extrajudicial.isDownloadingTemplate;
export const selectError = (state: RootState) => state.extrajudicial.error;

export const selectScheduleMode = (state: RootState) => state.extrajudicial.scheduleMode;
export const selectScheduledDate = (state: RootState) => state.extrajudicial.scheduledDate;
export const selectScheduledTime = (state: RootState) => state.extrajudicial.scheduledTime;

export const selectFormValido = (state: RootState) => {
  const { sendMethod, batchName, whatsappTemplateId, emailTemplateId, fisicoTemplateId } =
    state.extrajudicial.form;

  if (!batchName || !sendMethod) return false;

  switch (sendMethod) {
    case SendMethod.DIGITAL:
      return Boolean(whatsappTemplateId || emailTemplateId);
    case SendMethod.EMAIL_APENAS:
      return Boolean(emailTemplateId);
    case SendMethod.WHATSAPP_APENAS:
      return Boolean(whatsappTemplateId);
    case SendMethod.SEDEX:
      return Boolean(fisicoTemplateId);
    case SendMethod.DIGITAL_SEDEX:
      return Boolean((whatsappTemplateId || emailTemplateId) && fisicoTemplateId);
    default:
      return false;
  }
};

export const selectCurrentStep = (state: RootState) => state.extrajudicial.currentStep;
export const selectIsUploading = (state: RootState) => state.extrajudicial.isUploading;
export const selectUploadErrors = (state: RootState) => state.extrajudicial.uploadErrors;
export const selectPreValidationIssues = (state: RootState) =>
  state.extrajudicial.preValidationIssues;
export const selectPreValidationHasCritical = (state: RootState) =>
  state.extrajudicial.preValidationHasCritical;
export const selectPreValidationTotalRows = (state: RootState) =>
  state.extrajudicial.preValidationTotalRows;
export const selectLoteId = (state: RootState) => state.extrajudicial.loteId;
export const selectValidationResult = (state: RootState) => state.extrajudicial.validationResult;
export const selectIsValidatingDoc = (state: RootState) => state.extrajudicial.isValidatingDoc;
export const selectDocValidationData = (state: RootState) => state.extrajudicial.docValidationData;
export const selectDocLookupError = (state: RootState) => state.extrajudicial.docLookupError;

export const selectItemEditData = (state: RootState) => state.extrajudicial.itemEditData;
export const selectIsLoadingItemEdit = (state: RootState) => state.extrajudicial.isLoadingItemEdit;
export const selectIsUpdatingItem = (state: RootState) => state.extrajudicial.isUpdatingItem;

export const selectLotes = (state: RootState) => state.extrajudicial.lotes;
export const selectLotesPagination = (state: RootState) => state.extrajudicial.lotesPagination;
export const selectLotesDashboard = (state: RootState) => state.extrajudicial.lotesDashboard;
export const selectIsLoadingLotes = (state: RootState) => state.extrajudicial.isLoadingLotes;
export const selectLotesError = (state: RootState) => state.extrajudicial.lotesError;
export const selectLotesRascunho = (state: RootState) => state.extrajudicial.lotesRascunho;
export const selectIsLoadingLotesRascunho = (state: RootState) =>
  state.extrajudicial.isLoadingLotesRascunho;
export const selectTotalLotesRascunho = (state: RootState) =>
  state.extrajudicial.totalLotesRascunho;
export const selectAjustesGrupos = (state: RootState) => state.extrajudicial.ajustesGrupos;
export const selectAjustesEscopo = (state: RootState) => state.extrajudicial.ajustesEscopo;
export const selectIsLoadingAjustes = (state: RootState) => state.extrajudicial.isLoadingAjustes;
export const selectAjustesError = (state: RootState) => state.extrajudicial.ajustesError;

export const selectLoteAtual = (state: RootState) => state.extrajudicial.loteAtual;
export const selectLoteDetail = (state: RootState) => state.extrajudicial.loteDetail;
export const selectIsLoadingLote = (state: RootState) => state.extrajudicial.isLoadingLote;
export const selectLotePerformance = (state: RootState) => state.extrajudicial.lotePerformance;
export const selectIsLoadingLotePerformance = (state: RootState) =>
  state.extrajudicial.isLoadingLotePerformance;

export const selectStats = (state: RootState) => state.extrajudicial.stats;
export const selectIsLoadingStats = (state: RootState) => state.extrajudicial.isLoadingStats;

export const selectItensDoLote = (state: RootState) => state.extrajudicial.itensDoLote;
export const selectItensPagination = (state: RootState) => state.extrajudicial.itensPagination;
export const selectIsLoadingItens = (state: RootState) => state.extrajudicial.isLoadingItens;

export const selectNotificacoes = (state: RootState) => state.extrajudicial.notificacoes;
export const selectNotificacoesPagination = (state: RootState) =>
  state.extrajudicial.notificacoesPagination;
export const selectIsLoadingNotificacoes = (state: RootState) =>
  state.extrajudicial.isLoadingNotificacoes;
export const selectNotificacoesError = (state: RootState) => state.extrajudicial.notificacoesError;

export const selectEntregasPanel = (state: RootState) => state.extrajudicial.entregasPanel;

export const selectItemAtual = (state: RootState) => state.extrajudicial.itemAtual;
export const selectIsLoadingItem = (state: RootState) => state.extrajudicial.isLoadingItem;
export const selectDigitalSendSnapshot = (state: RootState) =>
  state.extrajudicial.digitalSendSnapshot;
export const selectIsLoadingDigitalSendSnapshot = (state: RootState) =>
  state.extrajudicial.isLoadingDigitalSendSnapshot;

export const selectIsEnviando = (state: RootState) => state.extrajudicial.isEnviando;

export const selectIsAgendando = (state: RootState) => state.extrajudicial.isAgendando;
export const selectIsCancelando = (state: RootState) => state.extrajudicial.isCancelando;
export const selectIsEncerrando = (state: RootState) => state.extrajudicial.isEncerrando;
export const selectIsArquivando = (state: RootState) => state.extrajudicial.isArquivando;
export const selectIsRestaurando = (state: RootState) => state.extrajudicial.isRestaurando;
export const selectIsAbrindoNegociacaoEmLote = (state: RootState) =>
  state.extrajudicial.isAbrindoNegociacaoEmLote;
export const selectNegociacaoEmLoteResult = (state: RootState) =>
  state.extrajudicial.negociacaoEmLoteResult;
export const selectSchedulingInfo = (state: RootState) => state.extrajudicial.schedulingInfo;
export const selectIsLoadingSchedulingInfo = (state: RootState) =>
  state.extrajudicial.isLoadingSchedulingInfo;

export const selectValoresEfetivos = (state: RootState) => state.extrajudicial.valoresEfetivos;
export const selectIsLoadingValores = (state: RootState) => state.extrajudicial.isLoadingValores;
export const selectCustosLote = (state: RootState) => state.extrajudicial.custosLote;
export const selectIsLoadingCustos = (state: RootState) => state.extrajudicial.isLoadingCustos;

export const selectIsCreatingDraft = (state: RootState) => state.extrajudicial.isCreatingDraft;
export const selectIsSavingConfig = (state: RootState) => state.extrajudicial.isSavingConfig;
export const selectIsAdvancing = (state: RootState) => state.extrajudicial.isAdvancing;
export const selectMetodosPermitidos = (state: RootState) => state.extrajudicial.metodosPermitidos;
export const selectIsLoadingMetodos = (state: RootState) => state.extrajudicial.isLoadingMetodos;

export const selectNotificacoesStats = (state: RootState) =>
  state.extrajudicial.notificacoesStats || {
    total: 0,
    enviadas: 0,
    falhas: 0,
    visualizadas: 0,
  };

export const selectIsLoadingNotificacoesStats = (state: RootState) =>
  state.extrajudicial.isLoadingNotificacoesStats;

export const selectLoteTabCounts = (state: RootState) => state.extrajudicial.loteTabCounts;
export const selectIsLoadingLoteTabCounts = (state: RootState) =>
  state.extrajudicial.isLoadingLoteTabCounts;

export const selectManifestacaoChat = (state: RootState) => state.extrajudicial.manifestacaoChat;
export const selectManifestacaoChatItemId = (state: RootState) =>
  state.extrajudicial.manifestacaoChatItemId;
export const selectIsLoadingManifestacaoChat = (state: RootState) =>
  state.extrajudicial.isLoadingManifestacaoChat;
export const selectIsEnviandoRespostaSimples = (state: RootState) =>
  state.extrajudicial.isEnviandoRespostaSimples;
export const selectErroManifestacaoChat = (state: RootState) =>
  state.extrajudicial.erroManifestacaoChat;
export const selectIsCarregandoAnterioresManifestacaoChat = (state: RootState) =>
  state.extrajudicial.isCarregandoAnterioresManifestacaoChat;
export const selectErroAnterioresManifestacaoChat = (state: RootState) =>
  state.extrajudicial.erroAnterioresManifestacaoChat;
